(function () {
    window.yaju = require('./js-utils.js');
})();
